import { graphqlShopifyStorefront } from "@repo/graphql-shopify-storefront";

export const Menu_Query = graphqlShopifyStorefront(`
  query menu(
    $country: CountryCode
    $handle: String!
    $language: LanguageCode
  ) @inContext(country: $country, language: $language) {
    menu(handle: $handle) {
      id
      items {
        id
        title
        url
      }
    }
  }
`);
